// export the base URL for the API
export const API_BASE =
  // process.env.REACT_APP_API_BASE || "http://localhost:3001";
  process.env.REACT_APP_API_BASE || "https://toldcardserver.vercel.app";

  console.log("*** API_BASE =", API_BASE);